import { EntityRatingComment } from '@medprev-web-app/api-graphql-client';

import { getEntityRatingCommentByIdService } from './entity-rating-comments-by-id.service';

import { getEntityRatingCommentCountService } from '@/app/(main)/(pages)/_services/entity-rating-comments-count.service';
import { getProfessionalCommentCount } from '@/app/(main)/(pages)/(institucional)/(index)/profissionais/_services/get-professional-comment-count.service';

export async function getCommentsAttributes(entityIds: { id: string }[]): Promise<(EntityRatingComment | null | undefined)[]> {
  const arrayPromisesComments = entityIds.map(({ id }) => getEntityRatingCommentByIdService(id));

  const comments = await Promise.all(arrayPromisesComments);

  return comments;
}

export async function fetchEntityCommentCountIds(
  professionalId?: string,
  partnerFacilityId?: string,
  page = 1,
): Promise<{ id: string | number }[]> {
  if (professionalId) {
    return (await getProfessionalCommentCount(professionalId, page))?.comments ?? [];
  } else if (partnerFacilityId) {
    return (await getEntityRatingCommentCountService(partnerFacilityId, page))?.comments ?? [];
  }

  return [];
}
